import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from 'react-router-scroll-top';
import LogoLoader from './newStyledComponents/Loaders/LogoLoader';
import I18NInitalize from './i18nInitalize';

import './scss/App.scss';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'jquery/dist/jquery.js';
import './i18n';

const supportsHistory = 'pushState' in window.history;
const App = React.lazy(() => import('./App'));

const host = window.location.hostname;

render((
  <BrowserRouter basename="/app" forceRefresh={!supportsHistory}>
    <ScrollToTop>
      <Suspense
        fallback={(
          <div className="logo-loader__wrapper">
            { !host.includes("nazorg-financieelfit") ? <LogoLoader src="/assets/images/logo/finsave-app-icon.svg" /> : <LogoLoader src="/assets/images/companies/financieelfit-logo.svg"/> }
            {/* { !host.includes("localhost") ? <LogoLoader src="/assets/images/logo/finsave-app-icon.svg" /> : <LogoLoader src="https://www.financieelfit.nl/content/themes/financieelfit/build/svg/logo-white.svg"/> } */}
            {/* <LogoLoader src="/assets/images/logo/finsave-app-icon.svg" /> */}
          </div>
        )}
      >
        <I18NInitalize>
          <App />
        </I18NInitalize>
      </Suspense>
    </ScrollToTop>
  </BrowserRouter>
), document.getElementById('root'));
